<template>
  <ValidationObserver tag="form" ref="observer">
    <h2 class="title is-size-5-mobile">{{ $t('general.your-data') }}</h2>
    <Separator />
    <h3 class="title is-size-5">{{ $t('general.user-data') }}</h3>
    <div class="block">
      <ValidationProvider name="Herr/Frau" rules="oneOf:10,20" v-slot="{errors}">
        <b-radio id="radioMale" v-model="customer.sex" name="sex" native-value="10">{{ $t('general.male') }}</b-radio>
        <b-radio id="radioFemale" v-model="customer.sex" name="sex" native-value="20">{{ $t('general.female') }}</b-radio>
        <p class="help is-danger" v-for="error in errors" :key="error">{{ error }}</p>
      </ValidationProvider>
    </div>
    <div class="columns is-multiline">
      <div class="column is-5 is-12-desktop is-5-widescreen">
        <ValidationProvider :name="$t('general.firstname')" :rules="{required: true}" v-slot="{errors}">
          <b-field :label="`${$t('general.firstname')}*`" expanded label-position="inside">
            <b-input name="firstName" v-model="customer.firstName"></b-input>
            <p class="help is-danger" v-for="error in errors" :key="error">{{ error }}</p>
          </b-field>
        </ValidationProvider>
      </div>
      <div class="column is-7 is-12-desktop is-7-widescreen">
        <ValidationProvider :name="$t('general.lastname')" :rules="{required: true}" v-slot="{errors}">
          <b-field :label="`${$t('general.lastname')}*`" expanded label-position="inside">
            <b-input name="lastName" v-model="customer.lastName"></b-input>
            <p class="help is-danger" v-for="error in errors" :key="error">{{ error }}</p>
          </b-field>
        </ValidationProvider>
      </div>
      <div class="column is-7 is-12-desktop is-7-widescreen">
        <ValidationProvider :name="$t('general.email')" :rules="{required: true, email: true}" v-slot="{errors}">
          <b-field :label="`${$t('general.email')}*`" expanded label-position="inside">
            <b-input name="mail" v-model="customer.email" inputmode="email"></b-input>
            <p class="help is-danger" v-for="error in errors" :key="error">{{ error }}</p>
          </b-field>
        </ValidationProvider>
      </div>
      <div class="column is-5 is-12-desktop is-5-widescreen">
        <b-field :label="$t('general.phone')" expanded label-position="inside">
          <b-input v-model="customer.phone" inputmode="tel"></b-input>
        </b-field>
      </div>
    </div>
    <Separator />
    <h3 class="title is-size-5">{{ $t('general.address-data') }}</h3>
    <div class="columns is-multiline">
      <div class="column is-7 is-12-desktop is-7-widescreen">
        <ValidationProvider :name="`${$t('general.street')} + ${$t('general.number')}`" :rules="{required: true}" v-slot="{errors}">
          <b-field :label="`${$t('general.street')} + ${$t('general.number')}*`" label-position="inside">
            <b-input name="streetInput" v-model="customer.address"></b-input>
            <p class="help is-danger" v-for="error in errors" :key="error">{{ error }}</p>
          </b-field>
        </ValidationProvider>
      </div>
      <div class="column is-5 is-12-desktop is-5-widescreen">
        <ValidationProvider :name="$t('general.country')" :rules="{required: true}" v-slot="{errors}">
          <b-field :label="`${$t('general.country')}*`" label-position="inside">
            <b-select :placeholder="$t('general.country')" v-model="customer.country" icon="globe" expanded>
              <option v-for="option in isoCountries" :value="option.iso" :key="option.iso">{{ option.country }}</option>
            </b-select>
            <p class="help is-danger" v-for="error in errors" :key="error">{{ error }}</p>
          </b-field>
        </ValidationProvider>
      </div>
      <div class="column is-4">
        <ValidationProvider :name="$t('general.zip')" :rules="{required: true, numeric: true}" v-slot="{errors}">
          <b-field :label="`${$t('general.zip')}*`" label-position="inside">
            <b-input name="plz" v-model="customer.zip" inputmode="numeric"></b-input>
            <p class="help is-danger" v-for="error in errors" :key="error">{{ error }}</p>
          </b-field>
        </ValidationProvider>
      </div>
      <div class="column is-8">
        <ValidationProvider :name="$t('general.city')" :rules="{required: true}" v-slot="{errors}">
          <b-field :label="`${$t('general.city')}*`" label-position="inside">
            <b-input name="city" v-model="customer.city"></b-input>
            <p class="help is-danger" v-for="error in errors" :key="error">{{ error }}</p>
          </b-field>
        </ValidationProvider>
      </div>
    </div>
    <small>(* {{ $t('general.required-field') }})</small>
  </ValidationObserver>
</template>

<script>
import Separator from '@/components/Separator'
import {mapGetters} from 'vuex'
export default {
  name: 'CustomerData',
  components: {
    Separator,
  },
  props: {
    customer: Object,
  },
  computed: {
    ...mapGetters({
      isoCountries: 'isoCountries',
    }),
  },
  async mounted() {
    const vf = this

    this.$watch(
      () => this.$refs.observer.errors,
      async () => {
        const isValid = await this.$refs.observer.validate({silent: true})
        vf.$emit('validated', isValid)
      },
    )
  },
  methods: {
    async runValidation() {
      const vf = this
      const isValid = await this.$refs.observer.validate()
      if (isValid) {
        vf.$emit('validated', isValid)
      }
    },
  },
}
</script>

<style scoped lang="scss"></style>
